module.exports = __webpack_public_path__ + "media/background.d60b0c59.mp3";